module.exports = __webpack_public_path__ + "media/images/soar/favicon-21f10fa646ef5f36b42501e6a9898e6d.gif";